var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModuleWrapper',{attrs:{"instance":_vm.instance,"backgroundColor":_vm.backgroundColor}},[_c('div',{class:[`${_vm.$appPrefix}-history-module`]},[_c('MgsContainer',[_c('MgsRow',[_c('MgsCol',[_c('div',{ref:"chart"})])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }